export const TRATAMIENTO_PAGOS_TYPE = {
    REINTEGRAR_CREDITO: 780,
    NO_REINTEGRAR: 781,
    APLICACION_DEUDA_ORIGINAL: 782
}
